
import React from "react";
import { Classname } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";

export interface SponsorsProps {
    sponsors: string[];
}

function Sponsors({ sponsors }: SponsorsProps) {

    const labels = i18nManager.Labels.home;

    if (!sponsors.length) return null;

    return (<section className={Classname.build(styles["section"], styles["bg-paper2"])}>
        <div className={styles["container"]}>
            <SectionHeader kicker={labels.sponsors_kicker} title={labels.sponsors_title} titleEm={labels.sponsors_title_em} subtitle={labels.sponsors_desc} />
            <div className={styles["sponsor-grid"]}>
                {sponsors.map((s) => (<div key={s} className={styles["sponsor"]}>
                    <img src={s} alt="" loading="lazy" />
                </div>))}
            </div>
        </div>
    </section>);
}

export default Sponsors;
